import { graphql } from '@app/graphql/types';
import { useMutation } from '@apollo/client';

const SUBMIT_PROOF = graphql(`
  mutation SubmitManualTransferProof($onlineOrderID: ID!, $input: SubmitManualTransferProofInput!) {
    storefront_onlineOrder_submitManualTransferProof(onlineOrderID: $onlineOrderID, input: $input)
  }
`);

export default function useSubmitManualTransferProof() {
  return useMutation(SUBMIT_PROOF, {
    refetchQueries: ['OnlineOrderDetailPage'],
    awaitRefetchQueries: true,
  });
}
